import { Button } from 'fukku/Button'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useProductCardConsumerLayoutContext } from 'product-card/hooks/useProductCardConsumerLayoutContext'
import { useProductCardContext } from 'product-card/hooks/useProductCardContext'
import type { ProductSize } from 'product/types/Product'
import { useCartController } from 'shopping-cart/hooks/useCartController'
import { cx } from 'utils/cx'

import text from 'fukku/styles/texts.module.scss'
import styles from 'product-card/components/shared/ProductSizes/AddToBag/AddToBagOneSizeButton/AddToBagOneSizeButton.module.scss'

interface AddToBagOneSizeButtonProps {
	size: ProductSize
	isOverlay?: boolean
}

export const AddToBagOneSizeButton = ({
	size,
	isOverlay = false,
}: AddToBagOneSizeButtonProps) => {
	const { t } = useLabels()
	const { productId, selectedColorId, lookId, location } =
		useProductCardContext()
	const { add } = useCartController()
	const { isOnPLP } = useProductCardConsumerLayoutContext()

	// TODO: remove this when we send the seller in the add to bag request
	const productSeller = 'mango'

	const onAdd = () => {
		add(
			{
				productId: size.relatedProductId ?? productId,
				sizeId: size.id,
				seller: productSeller,
				lookId: lookId.current,
				colorId: selectedColorId,
			},
			location
		)
	}

	return (
		<Button
			width='fill'
			secondary={!isOnPLP}
			className={cx(text.titleM, isOverlay && styles.overlayButton)}
			onClick={() => onAdd()}
		>
			{t('productCard.showSizes.button')}
		</Button>
	)
}
